module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "app-aside hidden-xs bg-black hidden-print ",
    class: {
      'off-screen': _vm.menuOpen
    },
    attrs: {
      "id": "aside"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "aside-wrap"
  }, [_c('div', {
    staticClass: "navi-wrap"
  }, [_c('nav', {
    staticClass: "navi clearfix",
    attrs: {
      "ui-nav": ""
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "m-t"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-windows icon text-primary"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'arrematantes'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users icon text-info"
  }), _vm._v(" "), _c('span', [_vm._v("Arrematantes")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'comitentes'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase icon text-success"
  }), _vm._v(" "), _c('span', [_vm._v("Comitentes")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'documentos'
      }
    }
  }, [_c('i', {
    staticClass: "icon-docs icon"
  }), _vm._v(" "), _c('span', [_vm._v("Documentos")])])], 1), _vm._v(" "), _c('MenuAdminSite'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'leilao'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gavel text-warning icon "
  }), _vm._v(" "), _c('span', [_vm._v("Leilões")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "ui-sref-active": "active"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'inadimplentes'
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-check icon text-danger-lter"
  }), _vm._v(" "), _c('span', {
    staticClass: "ng-scope"
  }, [_vm._v("Inadimplentes")])])], 1), _c('li', {
    attrs: {
      "ui-sref-active": "active"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'impedimentos'
      }
    }
  }, [_c('b', {
    staticClass: "badge bg-danger pull-right"
  }, [_vm._v("novo")]), _vm._v(" "), _c('i', {
    staticClass: "glyphicon glyphicon-ban-circle icon text-danger-lter"
  }), _vm._v(" "), _c('span', {
    staticClass: "ng-scope"
  }, [_vm._v("COAF")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "line dk hidden-folded"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.ACL.check('gerenciar_usuario_intranet', _vm.currentUser.id)) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'usuarios'
      }
    }
  }, [_c('i', {
    staticClass: "icon-user icon text-success-lter"
  }), _vm._v(" "), _c('span', [_vm._v("Usuários")])])], 1) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('MenuBI'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'relatorios-basico'
      }
    }
  }, [_c('i', {
    staticClass: "icon-list icon "
  }), _vm._v(" "), _c('span', [_vm._v("Relatórios Básicos")])])], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', {
    attrs: {
      "ui-sref-active": "active"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'contatos'
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-envelope icon text-info-lter"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-bold ng-scope"
  }, [_vm._v("Atendimento")])])], 1), _vm._v(" "), (_vm.ACL.check('rh', _vm.currentUser.id)) ? _c('li', {
    attrs: {
      "ui-sref-active": "active"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'trabalhe.conosco.index'
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-envelope icon text-info-lter"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-bold ng-scope"
  }, [_vm._v("Trabalhe Conosco")])])], 1) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.$parent.toggleChat()
      }
    }
  }, [_c('i', {
    staticClass: "icon-bubbles icon text-info"
  }), _vm._v(" "), _c('span', [_vm._v("Chat")])])])], 1)]), _vm._v(" "), _vm._m(5)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "hidden-folded padder m-t m-b-sm text-muted text-xs"
  }, [_c('span', [_vm._v("Apps")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "hidden-folded padder m-t m-b-sm text-muted text-xs"
  }, [_c('span', [_vm._v("Colaborativo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "hidden-folded padder m-t m-b-sm text-muted text-xs"
  }, [_c('span', [_vm._v("Estatísticas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "hidden-folded padder m-t m-b-sm text-muted text-xs"
  }, [_c('span', [_vm._v("Comunicação e Marketing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://m.rogeriomenezes.com.br",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-location-arrow icon text-primary"
  }), _vm._v(" "), _c('span', [_vm._v("Automação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper m-t hidden"
  }, [_c('div', {
    staticClass: "text-center-folded"
  }, [_c('span', {
    staticClass: "pull-right pull-none-folded"
  }, [_vm._v("50%")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-folded"
  }, [_vm._v("Metas do mês")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xxs m-t-sm dk"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-info",
    staticStyle: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center-folded"
  }, [_c('span', {
    staticClass: "pull-right pull-none-folded"
  }, [_vm._v("50%")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-folded"
  }, [_vm._v("Metas do dia")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xxs m-t-sm dk"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    staticStyle: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center-folded"
  }, [_c('span', {
    staticClass: "pull-right pull-none-folded"
  }, [_vm._v("50%")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-folded"
  }, [_vm._v("Leitura dos avisos")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xxs m-t-sm dk"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger",
    staticStyle: {
      "width": "50%"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55308423","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/Menu.vue
// module id = 789
// module chunks = 2